

<app-header *ngIf="userDataReady && appHeaderEnabled" (toggle)="setSidebarVisibility()"></app-header>

<div *ngIf="userDataReady && appMenuEnabled" [class.full-height]="!appHeaderEnabled" [@slideInOut]="menuState" class="sid-sidenav bg-dark">
   <app-menu (toggle)="setSidebarVisibility()"></app-menu>
</div>

<div *ngIf="userDataReady" class="sid-main" [class]="{'full-height': !appHeaderEnabled, 'w-70': appObjectInfoEnabled}" [@slideMap]="menuState">
   <router-outlet></router-outlet>
</div>

<div *ngIf="userDataReady && appObjectInfoEnabled" [class]="{'full-height': !appHeaderEnabled, 'w-30': appObjectInfoEnabled}" class="object-info-menu">
   <app-object-info></app-object-info>
</div>